import type { DocumentLock } from '@ztechapps/common.contract'
import { DocumentLockKeyEnum } from '@ztechapps/common.contract'
import type { UseDocumentLockResult } from '@ztechapps/common.hook'
import { useDocumentLock } from '@ztechapps/common.hook'

export type UseLogisticDocumentLock = { value: string; initialValue?: DocumentLock }
export const useLogisticDocumentLock = ({ value, initialValue }: UseLogisticDocumentLock): UseDocumentLockResult => {
  return useDocumentLock({
    key: DocumentLockKeyEnum.Logistic,
    value,
    initialValue,
  })
}
